import { render, staticRenderFns } from "./UpdateUserPass.vue?vue&type=template&id=19547482&scoped=true"
import script from "./UpdateUserPass.vue?vue&type=script&lang=js"
export * from "./UpdateUserPass.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserPass.vue?vue&type=style&index=0&id=19547482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19547482",
  null
  
)

export default component.exports